import React, { useEffect, useRef, useState } from 'react';
import { Container, makeStyles, Grid, Button, Typography, Table, TableCell, TableRow, TableBody, Fade, Stepper, Step, StepLabel, colors } from '@material-ui/core';
import Page from 'components/Page';

import { FormatNumber, Header } from 'components';
import { ModalGeneral } from 'components';
// import serviciosOrden from 'utils/serviciosOrden'

import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import FormularioMAReq from './FormularioMAReq';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';

const useStyles = makeStyles((theme) => ({
    step: {
        "&$completed": {
            color: "rgb(76,175,80)"
        },
        "&$active": {
            color: theme.palette.primary
        },
    },
    btnAceptar: {
        color: colors.green[500],
    },
    active: {}, //needed so that the &$active tag works
    completed: {},
    // disabled: {},
}));

// const actualizarEquipo = (personas, dataGeneral, condiciones) => {
//     let arrPersonas = dataGeneral.map(persona => persona.idpersona);
//     if (condiciones.cond1)
//         personas = personas.filter(per => arrPersonas.includes(per.idpersona));
//     return personas;
// }

const RequerimientoMa = ({ setMensaje, datoS, ctls, setCargando, edicionEspecial, permisos, guardar, accion, tipo, servicios, ...props }) => {
    //inicializa variables
    const classes = useStyles();
    const formref = useRef();
    const [tabValue, setTabValue] = useState(0);
    const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
    const [ctl, setCtl] = useState({ proyectos: [], personas: datoS?.personas || [] });
    const [data, setData] = useState({ general: datoS || {} });
    const { register, unregister, handleSubmit, errors, watch, setValue, getValues, control } = useForm();
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fechaActual = year + '-' + month + '-' + day;
    const disponible = datoS.estatusPropuesta ? (datoS.estatusPropuesta == 6 ? false : true) : false;
    const [cambio, setCambio] = useState(false);

    // const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });

    // const guardarDataGeneral = (dataGeneral) => { //, cond1
    //     console.log(dataGeneral);
        // setData({
        //     ...data,
        //     general: {
        //         ...data.general,
        //         requerimiento: dataGeneral?.requerimiento
        //     }
        // });
        // setTabValue(1);
    // }


    // const cambioPaso = (paso, nuevoData) => event => {
    //     setTabValue(paso);
    //     if (nuevoData)
    //         setData({ ...data, ...nuevoData });
    // }

    useEffect(() => {
        // register('requerimiento', { required: { value: true, message: 'Campo requerido' } });
        register('hrs_testeo_ma', { required: { value: true, message: 'Campo requerido' } });
        register('aplicarReq_ma');
    }, []);

    useEffect(() => {
        if (tabValue == 0) {
            if (data.general?.hrs_testeo_ma) {
                setValue('hrs_testeo_ma', data.general.hrs_testeo);
                setValue('aplicarReq_ma', data.general.aplicarReq);
            } else {
                // setValue('requerimiento', null);
                setValue('hrs_testeo_ma', null);
                setValue('aplicarReq_ma', false);
            }
        }
    }, [tabValue, data]);
    return (
        <Container maxWidth={false}>
            {/* <Stepper activeStep={tabValue} orientation="horizontal">
                <Step>
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: classes.step,
                                completed: classes.completed,
                                active: classes.active,
                                disabled: classes.disabled
                            }
                        }}
                    >DATOS DE MODIFICACIÓN DE ALCANCE</StepLabel>
                </Step>
                <Step key={1}
                    StepIconProps={{
                        classes: {
                            root: classes.step,
                            completed: classes.completed,
                            active: classes.active,
                            disabled: classes.disabled
                        }
                    }}>
                    <StepLabel>GUARDAR MODIFICACIÓN DE ALCANCE</StepLabel>
                </Step>
            </Stepper>
            <Fade in={tabValue === 0} style={{ display: tabValue === 0 ? 'block' : 'none' }}>
                <Container> */}
                    <form autocomplete="off" onSubmit={handleSubmit(guardar)}>
                        <FormularioMAReq
                            register={register}
                            errors={getErrorMessage(errors)}
                            watch={watch}
                            ctlg={{ ...ctls, proyectos: ctl.proyectos }}
                            isEdicion={disponible}
                            // bucarEquipo={bucarEquipo}
                            defaultItem={data || {}} unregister={unregister}
                            setValue={setValue} permisos={permisos}
                            getValues={getValues} control={control}
                            setCargando={setCargando}
                        />
                        <Grid item container justify="flex-end">
                            <Button type="submit" className={classes.btnAceptar} ref={formref} style={{ textAlign: 'end' }}>Guardar</Button>
                            {/* <Button type="submit" className={classes.btnAceptar} ref={formref} style={{ textAlign: 'end' }}>Siguiente</Button> */}
                        </Grid>
                    </form>
                {/* </Container>
            </Fade>
            <Fade in={tabValue === 1} style={{ display: tabValue === 1 ? 'block' : 'none' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="subtitle1" style={{ margin: 'auto' }}>
                            Favor de verificar que todos los datos son correctos antes de guardar
                        </Typography>
                    </Grid>
                    {tabValue === 1 && <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell variant="head" >SOLICITUD # {data.general.idsolicitud}</TableCell>
                                        <TableCell variant="body" colSpan={3} >{data.general.titulo}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell variant="head" style={{ textAlign: "center" }}>REQUERIMIENTOS</TableCell>
                                    </TableRow>
                                    <TableRow>
                                    <TableCell variant="body" >Aplicar requerimientos: {data.general.aplicarReq?'Sí':'No'}</TableCell>
                                         <TableCell variant="body" >{data.general.requerimiento}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>}
                        <Grid item container justify="space-between">
                            <Button variant="text" color="secondary" className onClick={cambioPaso(0)}>Regresar</Button>
                            <Button variant="text" color="primary" onClick={() => guardar(data, cambio)}>Guardar propuesta</Button>
                        </Grid>
                    </Grid>
            </Fade> 
            // <ModalGeneral
            //     open={mAdvertencia.open}
            //     titulo='Advertencia'
            //     width='sm'
            //     ContenidoMensaje={mAdvertencia.mensaje}
            //     acciones={<React.Fragment>
            //         <Button className="btnError" color="secondary" onClick={cerrarAdvertencia}>CERRAR</Button>
            //         {Boolean(mAdvertencia.aceptar) &&
            //             <Button color="primary" onClick={mAdvertencia.aceptar}>ACEPTAR</Button>
            //         }
            //     </React.Fragment>}
            />*/}
        </Container>
    );
};

export default RequerimientoMa;